import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import image404 from '../assets/images/404.png'
import './page404.css'


export class Page404 extends Component {

  render() {
    return (
      <div className='page_error'>
        <a href="/">
          <img src={image404} alt="404" />
        </a>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Page404)))